import { JSXElement, mergeProps, Show } from 'solid-js';
import { Button } from '~/components/ui/Button';
import { twMerge } from 'tailwind-merge';

type ActionableContainerWithTitleProps = {
  id?: string;
  header?: JSXElement;
  subHeader?: JSXElement;
  ctaLabel?: JSXElement | string;
  isCtaLoading?: boolean;
  isCtaDisabled?: boolean;
  onCtaClick?: (e: Event) => void;
  children?: JSXElement;
  class?: string;
  titleContainerClass?: string;
  ctaDataTestId?: string;
  classList?: Record<string, boolean | undefined>;
};

export function ActionableContainerWithTitle(
  props: ActionableContainerWithTitleProps
): JSXElement {
  const merged = mergeProps(
    {
      id: new Date().getTime(),
      isCtaLoading: false,
      isCtaDisabled: false,
      class: '',
      titleContainerClass: '',
      onCtaClick: () => {}
    },
    props
  );
  return (
    <div
      class={twMerge(
        `p-6 mt-6 border border-e-bg-emphasized rounded-md`,
        merged.class
      )}
      classList={merged?.classList}
      data-testid={`container-${merged.id}`}
    >
      <div
        class={twMerge(
          `flex justify-between items-start `,
          merged.titleContainerClass
        )}
      >
        <div class={`flex-grow`}>
          <Show when={merged.header}>
            <h2 class={'font-medium'}>{merged.header}</h2>
          </Show>
          <Show when={merged.subHeader}>
            <p class={`mt-1 text-sm text-fg-muted`}>{merged.subHeader}</p>
          </Show>
        </div>
        <Show when={merged.ctaLabel}>
          <div class={`flex self-stretch items-start`}>
            <Show
              when={typeof merged.ctaLabel === 'string'}
              fallback={merged.ctaLabel}
            >
              <Button
                disabled={merged.isCtaDisabled}
                variant={`outline`}
                size={`sm`}
                onClick={merged.onCtaClick}
                loading={merged.isCtaLoading}
                data-testid={merged.ctaDataTestId ?? `cta-${merged.id}`}
              >
                {merged.ctaLabel}
              </Button>
            </Show>
          </div>
        </Show>
      </div>
      <Show when={merged.children}>{merged.children}</Show>
    </div>
  );
}
